export default {
  metrics: {
    nrr: {
      title: 'NRR % (Trimestrial)',
      description:
        '(Venituri abonamente {{currentMonth}} (T{{currentQuarter}}) + Venituri taxe servicii {{currentMonth}} (T{{currentQuarter}})) / (Venituri abonamente {{prevMonth}} (sfârșitul T{{prevQuarter}}) + Venituri taxe servicii {{prevMonth}} (sfârșitul T{{prevQuarter}})) * 100',
    },
    upgrades: 'Upgrade-uri cont',
    downgrades: 'Downgrade-uri cont',
    gte_c_tier: 'Conturi ≥ Nota C',
    churn: 'Churn (suspendate)',
    offers_turned_on: 'Oferte activate',
    flyers_sent: 'Flyere trimise',
    on_google_ads_trial: 'În trial Google Ads',
    converted_google_ads: 'Google Ads convertit cu succes',
    first_time_500_monthly_sales: 'Prima lună cu €500 vânzări',
    '14_days_no_sales': '14 zile live, fără venituri',
  },
  details: {
    address: 'Adresă',
    subscriptions: 'Abonamente curente',
    best_sales: 'Cea mai bună lună',
    sales: 'Vânzări {{month}}',
    tier: 'Nivel {{month}}',
    live_from: 'Data Go-Live',
    owner_phone: 'Telefon proprietar',
    owner_email: 'Email proprietar',
    owner: 'Nume proprietar',
    name: 'Restaurant',
    export_csv: 'Export CSV',
  },
  publish: 'Publică',
  unpublish: 'Anulează publicarea',
};
